
// import React from "react";

// const AdminRevenue = () => {
//   // 🔹 Dummy summary data
//   const summary = {
//     totalSiteRevenue: 125000,
//     platformIncome: 18500,
//     sellerEarnings: 95000,
//     subadminEarnings: 6500,
//     pendingPayouts: 22000,
//   };

//   // 🔹 Revenue breakdown
//   const revenueSources = [
//     { name: "Order Commission", amount: 14200 },
//     { name: "Banner Sponsorships", amount: 3200 },
//     { name: "Offer Promotions", amount: 1100 },
//   ];

//   // 🔹 Subadmin revenue
//   const subadmins = [
//     {
//       name: "Kochi Subadmin",
//       sellers: 12,
//       revenueGenerated: 42000,
//       commissionEarned: 3200,
//     },
//     {
//       name: "Trivandrum Subadmin",
//       sellers: 9,
//       revenueGenerated: 31000,
//       commissionEarned: 2100,
//     },
//     {
//       name: "Calicut Subadmin",
//       sellers: 6,
//       revenueGenerated: 19000,
//       commissionEarned: 1200,
//     },
//   ];

//   return (
//     <div className="p-6 space-y-8">
//       <h1 className="text-2xl font-bold">Revenue Overview</h1>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
//         <SummaryCard title="Total Site Revenue" value={summary.totalSiteRevenue} />
//         <SummaryCard title="Platform Income" value={summary.platformIncome} />
//         <SummaryCard title="Seller Earnings" value={summary.sellerEarnings} />
//         <SummaryCard title="Subadmin Earnings" value={summary.subadminEarnings} />
//         <SummaryCard title="Pending Payouts" value={summary.pendingPayouts} />
//       </div>

//       {/* Revenue Sources */}
//       <div className="bg-white shadow rounded-lg p-4">
//         <h2 className="font-semibold mb-4">Revenue Sources</h2>
//         <ul className="space-y-2">
//           {revenueSources.map((item, index) => (
//             <li key={index} className="flex justify-between">
//               <span>{item.name}</span>
//               <span className="font-medium">₹{item.amount}</span>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Subadmin Revenue Table */}
//       <div className="bg-white shadow rounded-lg p-4">
//         <h2 className="font-semibold mb-4">Subadmin Revenue</h2>
//         <table className="w-full text-sm border">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="p-2 border">Subadmin</th>
//               <th className="p-2 border">Sellers</th>
//               <th className="p-2 border">Revenue Generated</th>
//               <th className="p-2 border">Commission Earned</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subadmins.map((sub, index) => (
//               <tr key={index}>
//                 <td className="p-2 border">{sub.name}</td>
//                 <td className="p-2 border text-center">{sub.sellers}</td>
//                 <td className="p-2 border">₹{sub.revenueGenerated}</td>
//                 <td className="p-2 border font-medium">₹{sub.commissionEarned}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const SummaryCard = ({ title, value }) => (
//   <div className="bg-white shadow rounded-lg p-4">
//     <p className="text-sm text-gray-500">{title}</p>
//     <p className="text-xl font-bold mt-1">₹{value}</p>
//   </div>
// );

// export default AdminRevenue;


import React, { useEffect, useState } from "react";
import {
  PlatformIncomeFetchApi,
  SubadminPerformanceFetchApi,
  RevenueSummaryFetchApi,
} from "../../ApiCalls/Revenue";

const AdminRevenue = () => {
  const [kpis, setKpis] = useState(null);
  const [incomeSources, setIncomeSources] = useState([]);
  const [subadmins, setSubadmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRevenueData();
  }, []);

  const fetchRevenueData = async () => {
    try {
      setLoading(true);

      const [summaryRes, platformRes, subadminRes] = await Promise.all([
        RevenueSummaryFetchApi(),
        PlatformIncomeFetchApi(),
        SubadminPerformanceFetchApi(),
      ]);

      /* ================= KPI SUMMARY ================= */
      setKpis({
        gmv: summaryRes?.data?.total_gvm || 0,
        adminIncome: summaryRes?.data?.admin_income || 0,
        sellerNetEarnings: summaryRes?.data?.seller_net_earnings || 0,
        subadminCommission: summaryRes?.data?.subadmin_commissions || 0,
        pendingPayouts: summaryRes?.data?.pending_seller_payouts || 0,
      });

      /* ================= PLATFORM INCOME ================= */
      setIncomeSources([
  {
    name: "Admin Earned",
    amount: Number(platformRes?.admin_earned) || 0,
  },
  {
    name: "Banner",
    amount:
      platformRes?.Banner === "-" ? 0 : Number(platformRes?.Banner || 0),
  },
  {
    name: "Sponsored",
    amount:
      platformRes?.Sponsored === "-" ? 0 : Number(platformRes?.Sponsored || 0),
  },
  {
    name: "Offer",
    amount:
      platformRes?.Offer === "-" ? 0 : Number(platformRes?.Offer || 0),
  },
]);


      /* ================= SUBADMIN PERFORMANCE ================= */
      setSubadmins(subadminRes?.data || []);
    } catch (error) {
      console.error("Failed to load admin revenue dashboard", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !kpis) {
    return <p className="p-6">Loading revenue data...</p>;
  }

  return (
    <div className="p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Admin Revenue Dashboard</h1>
        <span className="text-sm text-gray-500">
          Showing data for: This Month
        </span>
      </div>

      {/* ================= KPI CARDS ================= */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <KpiCard title="GMV" value={kpis.gmv} />
        <KpiCard title="Admin Income" value={kpis.adminIncome} highlight />
        <KpiCard title="Seller Net Earnings" value={kpis.sellerNetEarnings} />
        <KpiCard title="Subadmin Commission" value={kpis.subadminCommission} />
        <KpiCard title="Pending Payouts" value={kpis.pendingPayouts} danger />
      </div>

      {/* ================= PLATFORM INCOME ================= */}
      <div className="bg-white shadow rounded-lg p-5">
        <h2 className="font-semibold mb-4">Platform Income Breakdown</h2>
        <div className="space-y-3">
          {incomeSources.map((src, i) => (
            <div key={i} className="flex justify-between text-sm">
              <span>{src.name}</span>
              <span className="font-semibold text-green-700">
                ₹{src.amount}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ================= SUBADMIN PERFORMANCE ================= */}
      <div className="bg-white shadow rounded-lg p-5">
        <h2 className="font-semibold mb-4">Subadmin Performance</h2>
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left">Subadmin</th>
              <th className="p-2 text-center">Sellers</th>
              <th className="p-2 text-right">GMV</th>
              <th className="p-2 text-right">Commission</th>
            </tr>
          </thead>
          <tbody>
            {subadmins.map((s) => (
              <tr key={s.subadmin_id} className="border-t">
                <td className="p-2">{s.subadmin_name}</td>
                <td className="p-2 text-center">{s.sellers_managed}</td>
                <td className="p-2 text-right">₹{s.gvm}</td>
                <td className="p-2 text-right font-semibold">
                  ₹{s.commission_earned}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const KpiCard = ({ title, value, highlight, danger }) => (
  <div
    className={`bg-white shadow rounded-lg p-4 ${
      highlight ? "border-l-4 border-green-500" : ""
    } ${danger ? "border-l-4 border-red-500" : ""
    }`}
  >
    <p className="text-sm text-gray-500">{title}</p>
    <p className="text-xl font-bold mt-1">₹{value}</p>
  </div>
);

export default AdminRevenue;
